import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { AiAssistantConfig, AssistantFieldLockMap } from './interfaces/config.interface';
import { AiAssistant, AiConnection, NamespaceConfig } from './interfaces/ai-assistant.interface';
import { PlatformLocation } from './ai-assistant.constants';

export const AI_ASSISTANT_CONFIG_TOKEN = new InjectionToken<AiAssistantConfig>(
  '[AiAssistant]: token for configuration',
);

export const ACCOUNT_GROUP_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiAssistant]: token for accountGroupId',
);

export const MARKET_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiAssistant]: token for marketId',
);

export const PARTNER_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiAssistant]: token for partnerId',
);

export const AI_DEFAULT_WORKFORCE_TOKEN: InjectionToken<Observable<AiAssistant[]>> = new InjectionToken(
  '[AiAssistant]: token for ai default workforce',
);

export const AI_DEFAULT_CONNECTIONS_TOKEN: InjectionToken<Observable<AiConnection[]>> = new InjectionToken(
  '[AiAssistant]: token for ai default connections',
);

export const CURRENT_USER_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiAssistant]: token for currentUserId',
);

export const VOICE_AI_AVAILABLE_TOKEN: InjectionToken<Observable<boolean>> = new InjectionToken(
  '[AiAssistant]: token for voice ai available',
);

export const SHOW_CUSTOM_ASSISTANT_TOKEN: InjectionToken<Observable<boolean>> = new InjectionToken(
  '[AiAssistant]: token for show custom assistant',
);

export const NAMESPACE_CONFIG_TOKEN: InjectionToken<Observable<NamespaceConfig>> = new InjectionToken(
  '[AiAssistant]: token for namespace configuration',
);

export const PLATFORM_LOCATION_TOKEN: InjectionToken<PlatformLocation> = new InjectionToken(
  '[AiAssistant]: token for platformLocation',
);

export const AI_MARKETER_AVAILABLE_TOKEN: InjectionToken<Observable<boolean>> = new InjectionToken(
  '[AiAssistant]: token for if the AI Marketer is available',
);

export const CRM_UPDATE_MORE_ENTITIES_ENABLED_TOKEN: InjectionToken<Observable<boolean>> = new InjectionToken(
  '[AiAssistant]: token for CRM Update more entities config (opportunities, custom objects)',
);

export const PRIMARY_OPERATING_LANGUAGE_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  '[AiAssistant]: token for the business primary operating language',
);

export const NAVIGATE_TO_OPERATING_LANGUAGE_TOKEN: InjectionToken<(() => void) | undefined> = new InjectionToken(
  '[AiAssistant]: token for navigating to the business profile operating language field',
);

export const ASSISTANT_FIELD_LOCKS_TOKEN: InjectionToken<Observable<AssistantFieldLockMap>> = new InjectionToken(
  '[AiAssistant]: token for the per-field lock map on the assistant edit form',
);
